require('alpinejs');
import Vue from 'vue'

const bootstrap = require('bootstrap')

console.log('starting vue');
import selectmultiple from './components/selectmultiple.vue';
import priceslider from './components/priceslider.vue';
import feedback from './components/feedback.vue';
import portfolioenquiry from './components/portfolioenquiry.vue';
import eventtokenredemption from './components/eventtokenredemption.vue';
import products from './components/products.vue';
import product from './components/product.vue';




const app = new Vue({
  el: '#app',
  components: {
      selectmultiple,
      priceslider,
      feedback,
      portfolioenquiry,
      eventtokenredemption,
      products,
      product,
  }
});



jQuery('.auto-submit').change(function() {
  jQuery(this).closest("form").submit();
});

jQuery(document).ready(function() {
  jQuery('.card').click(function() {
    window.location = jQuery(this).find("a").attr("href");
    return false;
  });
});